export function generate_path(input_code, input_label, input_description, input_type,
    output_code, output_label, output_description, output_type, output_data, edge_description = '', edge_accuracy = 1.0) {

    let input = { 'code': input_code, 'label': input_label, 'description': input_description, 'type': input_type };
    let output = { 'code': output_code, 'label': output_label, 'description': output_description, 'type': output_type, 'data': output_data };

    let edge = { 'accuracy': edge_accuracy, 'description': edge_description };

    return {'input': input, 'output': output, 'edge': edge }
}